import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { powerBiCRUD } from "../../http";
import LoadingContainer from "../../components/Loader/LoadingContainer";
import Ses18Filter from "./Ses18Filter";

const Ses18Table10 = () => {    
    const [query, setQuery] = useState({
        paging: { skip: 0 },
        filter: {}
    });
    const [data, setData] = useState({ rows: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAsync = async () => {
        setIsLoading(true);

        try {
            let response = await powerBiCRUD.post("table10", query);
            setData(response);

            setIsLoading(false);
        } catch (err) {
            setError(err.message || "Ошибка при загрузке данных");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchAsync();
    }, [query]);

    if (error) {
    return <div>Ошибка: {error}</div>;
    }

    if (!data) {
    return <div>Нет данных для отображения</div>;
    }

    return (
        <DashboardLayout>
            <Ses18Filter query={query} setQuery={setQuery} />
        <LoadingContainer loading={isLoading}>
            <table className="table table-bordered ses18-table">
                <thead>
                    <tr>
                        <th rowSpan={4}>Наименование продовольственного сырья и пищевых продуктов</th>
                        <th rowSpan={4}>№ строки</th>
                        <th rowSpan={4}>Исследова но проб по санитарно-химическим показателям, единиц</th>
                        <th rowSpan={4}>Из них не отвечают требованиям НД</th>
                        <th colSpan={13}>В том числе по показателям</th>                        
                        <th rowSpan={4}>Исследовано проб на остаточные количества пестици дов, единиц</th>
                        <th rowSpan={4}>Из них не отвечают требованиям НД</th>
                        <th rowSpan={4}>Исследо-вано проб на микробиологические показатели, единиц</th>
                        <th rowSpan={4}>Из них не отвечают требованиям НД</th>
                        <th rowSpan={4}>Исследовано на паразитологичес кие показатели, единиц</th>
                        <th rowSpan={4}>Из них не отвечают требованиям НД</th>

                        <th colSpan={3}>Объем забракованного и уничтоженного сырья пищевых продуктов (в кг)</th>
                    </tr>
                    <tr>
                        <th rowSpan={3}>органолептическим</th>
                        <th rowSpan={3}>физико-химичес-ким</th>
                        <th rowSpan={3}>токсич-ным химическим элементам</th>
                        <th rowSpan={3}>микоток синам</th>
                        <th rowSpan={3}>бенз(а)пирен</th>
                        <th rowSpan={3}>нитро замины</th>
                        <th rowSpan={3}>идентификация ткани животных</th>
                        <th rowSpan={3}>генетически модифицированные организмы</th>
                        <th rowSpan={3}>маркировка</th>
                        <th rowSpan={3}>антибиотики</th>
                        <th rowSpan={3}>гормоны</th>
                        <th rowSpan={3}>фортификация муки</th>
                        <th rowSpan={3}>ЖКС (трансжиры)</th>                        
                    </tr>
                    <tr>
                        <th rowSpan={2}>Всего</th>
                        <th colSpan={2}>в том числе</th>
                    </tr>
                    <tr>
                        <th>произведенных РК</th>
                        <th>ввозимых из других стран</th>
                    </tr>
                    <tr>
                        <th>А</th>
                        <th>Б</th>
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                        <th>5</th>
                        <th>6</th>
                        <th>7</th>
                        <th>8</th>
                        <th>9</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>13</th>
                        <th>14</th>
                        <th>15</th>
                        <th>16</th>
                        <th>17</th>
                        <th>18</th>
                        <th>19</th>
                        <th>20</th>
                        <th>21</th>
                        <th>22</th>
                        <th>23</th>
                        <th>24</th>
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map((row, index) => (
                        <tr key={index}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </LoadingContainer>
        </DashboardLayout>
    )
};

export default Ses18Table10;
